export default __webpack_public_path__ + "static/media/decreasefont.da0470d6.svg";